// @flow
import { createReducer } from "redux-act";
import * as _ from "lodash";
import * as actions from "../../actions/teamsDraft";

export const initial_state = {
	pre_draft_list: [],
	is_pre_draft_list_received: false,
	lineups: {},
	user_team: {},
	is_team_saving: false,
	is_rfa_order_saving: false,
	waiver_requests: "",
	trades: {},
	user_all_teams: [],
	is_pre_draft_list_successfully_saved: undefined,
	by_id: {},
	offer_trades: [],
	error: null,
};

const onError = (state, payload) => ({
	...state,
	error: payload,
	is_team_saving: false,
	is_pre_draft_list_successfully_saved: undefined,
});

const clearError = state => ({
	...state,
	error: false,
});

const onSuccessUpdatePreDraftList = (state, payload) => ({
	...state,
	pre_draft_list: payload,
});

const replaceUserTeam = (state, lineup, id) => {
	const all_teams = state.user_all_teams;
	const index = _.findIndex(all_teams, { id });
	if (index !== -1) {
		return [
			..._.slice(all_teams, 0, index),
			{
				...all_teams[index],
				lineup,
			},
			..._.slice(all_teams, index + 1),
		];
	}
	return [...all_teams];
};

export const teamsDraft = createReducer({}, initial_state);

teamsDraft.on(actions.fetchPreDraftList, state => ({
	...state,
	pre_draft_list: [],
	is_pre_draft_list_received: false,
}));

teamsDraft.on(actions.fetchPreDraftSuccess, (state, payload) => ({
	...state,
	pre_draft_list: payload,
	is_pre_draft_list_received: true,
}));

teamsDraft.on(actions.fetchPreDraftFailed, (state, payload) => ({
	...state,
	error: payload,
	is_team_saving: false,
	is_pre_draft_list_successfully_saved: undefined,
	is_pre_draft_list_received: false,
}));

teamsDraft.on(actions.clearUpdatePreDraftListSuccessFlag, state => ({
	...state,
	is_pre_draft_list_successfully_saved: undefined,
}));

teamsDraft.on(actions.postPreDraftListSuccess, (state, payload) => ({
	...state,
	pre_draft_list: payload,
	is_pre_draft_list_successfully_saved: true,
}));

teamsDraft.on(actions.forceUpdatePreDraftList, onSuccessUpdatePreDraftList);

teamsDraft.on(actions.postPickedPlayerSuccess, state => state);
teamsDraft.on(actions.postSelectKeeperSuccess, state => state);
teamsDraft.on(actions.removeKeeperSuccess, state => state);

teamsDraft.on(actions.postAutoPickFlagSuccess, state => state);

teamsDraft.on(actions.postPreDraftListFailed, onError);
teamsDraft.on(actions.postSelectKeeperFailed, onError);
teamsDraft.on(actions.removeKeeperFailed, onError);

teamsDraft.on(actions.postPickedPlayerFailed, onError);

teamsDraft.on(actions.postAutoPickFlagFailed, onError);

teamsDraft.on(actions.postTeamUpdate, state => ({
	...state,
	is_team_saving: true,
}));
teamsDraft.on(actions.postTeamUpdateFailed, onError);
teamsDraft.on(actions.postTeamUpdateSuccess, (state, { lineup, id }: any) => ({
	...state,
	user_team: {
		...state.user_team,
		lineup,
	},
	by_id: {
		...state.by_id,
		[id]: {
			...state.by_id[id],
			lineup,
		},
	},
	user_all_teams: replaceUserTeam(state, lineup, id),
	is_team_saving: false,
}));

teamsDraft.on(actions.fetchSnapshot, state => state);
teamsDraft.on(actions.fetchSnapshotSuccess, (state, payload) => ({
	...state,
	snapshot: payload,
}));
teamsDraft.on(actions.fetchSnapshotFailed, onError);

teamsDraft.on(actions.fetchLineups, state => state);
teamsDraft.on(actions.fetchLineupsSuccess, (state, payload) => ({
	...state,
	lineups: payload,
}));
teamsDraft.on(actions.fetchLineupsFailed, onError);

teamsDraft.on(actions.fetchTeam, state => state);
teamsDraft.on(actions.fetchTeamSuccess, (state, payload: any) => ({
	...state,
	user_team: payload,
	by_id: {
		...state.by_id,
		[payload.id]: payload,
	},
}));
teamsDraft.on(actions.fetchTeamFailed, onError);
teamsDraft.on(actions.clearTeamErrors, clearError);

teamsDraft.on(actions.postRequestWaiver, state => ({
	...state,
	is_team_saving: true,
}));
teamsDraft.on(actions.postRequestWaiverSuccess, (state, payload) => ({
	...state,
	waiver_requests: payload,
	is_team_saving: false,
}));
teamsDraft.on(actions.postRequestWaiverClear, state => ({
	...state,
	waiver_requests: "",
}));

teamsDraft.on(actions.postRequestWaiverFailed, onError);

teamsDraft.on(actions.fetchMakeTrade, state => state);
teamsDraft.on(actions.fetchMakeTradeSuccess, (state, payload: any) => ({
	...state,
	trade_id: payload.trade_id,
}));
teamsDraft.on(actions.fetchMakeTradeFailed, onError);

teamsDraft.on(actions.fetchTrades, state => state);
teamsDraft.on(actions.fetchTradesSuccess, (state, payload: any) => ({
	...state,
	trades: payload,
}));
teamsDraft.on(actions.forceTradesSuccess, (state, payload: any) => ({
	...state,
	trades: payload,
}));
teamsDraft.on(actions.fetchTradesFailed, onError);
teamsDraft.on(actions.fetchApproveTradeFailed, onError);

teamsDraft.on(actions.fetchMyTeams, state => state);
teamsDraft.on(actions.fetchMyTeamsSuccess, (state, payload) => ({
	...state,
	user_all_teams: payload,
}));
teamsDraft.on(actions.fetchMyTeamsFailed, onError);

teamsDraft.on(actions.fetchRejectTradeFailed, onError);

teamsDraft.on(actions.fetchRemovePlayer, state => ({
	...state,
	is_team_saving: true,
}));
teamsDraft.on(actions.fetchRemovePlayerSuccess, (state, payload: any) => ({
	...state,
	is_team_saving: false,
	user_team: payload,
}));
teamsDraft.on(actions.fetchRemovePlayerFailed, onError);
teamsDraft.on(actions.postOrderWaiverTrade, state => ({
	...state,
	is_rfa_order_saving: true,
}));
teamsDraft.on(actions.postOrderWaiverTradeSuccess, state => ({
	...state,
	is_rfa_order_saving: false,
}));
teamsDraft.on(actions.postOrderWaiverTradeFailed, state => ({
	...state,
	is_rfa_order_saving: false,
}));
teamsDraft.on(actions.clearTeamsDraftErrors, state => ({
	...state,
	error: null,
}));

teamsDraft.on(actions.fetchPlayersOnOfferListSuccess, (state, payload) => ({
	...state,
	offer_trades: payload,
}));
teamsDraft.on(actions.fetchPlayersOnOfferListFailed, onError);

export default teamsDraft;


// WEBPACK FOOTER //
// ./src/modules/reducers/teamDraft/index.js